import {registerLocaleData} from '@angular/common';

import af from '@angular/common/locales/af';
import am from '@angular/common/locales/am';
import ar from '@angular/common/locales/ar';
import az from '@angular/common/locales/az';
import be from '@angular/common/locales/be';
import bg from '@angular/common/locales/bg';
import bn from '@angular/common/locales/bn';
import br from '@angular/common/locales/br';
import bs from '@angular/common/locales/bs';
import ca from '@angular/common/locales/ca';
import cs from '@angular/common/locales/cs';
import da from '@angular/common/locales/da';
import de from '@angular/common/locales/de';
import el from '@angular/common/locales/el';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import et from '@angular/common/locales/et';
import eu from '@angular/common/locales/eu';
import fa from '@angular/common/locales/fa';
import fi from '@angular/common/locales/fi';
import fr from '@angular/common/locales/fr';
import gl from '@angular/common/locales/gl';
import he from '@angular/common/locales/he';
import hi from '@angular/common/locales/hi';
import hr from '@angular/common/locales/hr';
import hu from '@angular/common/locales/hu';
import hy from '@angular/common/locales/hy';
import id from '@angular/common/locales/id';
import is from '@angular/common/locales/is';
import it from '@angular/common/locales/it';
import ja from '@angular/common/locales/ja';
import ka from '@angular/common/locales/ka';
import kk from '@angular/common/locales/kk';
import km from '@angular/common/locales/km';
import kn from '@angular/common/locales/kn';
import ko from '@angular/common/locales/ko';
import lt from '@angular/common/locales/lt';
import lv from '@angular/common/locales/lv';
import mk from '@angular/common/locales/mk';
import ml from '@angular/common/locales/ml';
import mn from '@angular/common/locales/mn';
import mr from '@angular/common/locales/mr';
import ms from '@angular/common/locales/ms';
import nb from '@angular/common/locales/nb';
import nl from '@angular/common/locales/nl';
import pl from '@angular/common/locales/pl';
import pt from '@angular/common/locales/pt';
import ro from '@angular/common/locales/ro';
import ru from '@angular/common/locales/ru';
import sk from '@angular/common/locales/sk';
import sl from '@angular/common/locales/sl';
import sq from '@angular/common/locales/sq';
import sr from '@angular/common/locales/sr';
import sv from '@angular/common/locales/sv';
import ta from '@angular/common/locales/ta';
import te from '@angular/common/locales/te';
import th from '@angular/common/locales/th';
import tr from '@angular/common/locales/tr';
import uk from '@angular/common/locales/uk';
import ur from '@angular/common/locales/ur';
import vi from '@angular/common/locales/vi';
import zh from '@angular/common/locales/zh';

/**
 * Enregistrement de toutes les locales utilisables
 */
export const LOCALES: Record<string,any> = {
    af,am,ar,az,be,bg,bn,br,bs,ca,cs,da,de,el,
    en,es,et,eu,fa,fi,fr,gl,he,hi,hr,hu,hy,
    id,is,it,ja,ka,kk,km,kn,ko,lt,lv,mk,ml,
    mn,mr,ms,nb,nl,pl,pt,ro,ru,sk,sl,sq,sr,
    sv,ta,te,th,tr,uk,ur,vi,zh
};

/**
 * Charge une locale à partir du code
 * @param localeCode le code
 */
export function loadLocale(localeCode: string): void {
    const normalized = localeCode.toLowerCase();
    const locale = LOCALES[normalized];

    if (locale) {
        registerLocaleData(locale);
    } else {
        registerLocaleData(fr);
    }
}